require('./openYoungCardExpensesBars.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');

// @commons
const { ComparativeBarSimple } = require('commonsComponents/comparativeBarSimple');

const BAR_COLORS = {
    main: '#2CCEFD',
    secondary: '#AFBDC4'
}
const BAR_HEIGHT = 5;

const OpenYoungCardExpensesBars = props => {
    const {maxExpenses, currentPeriod, comparePeriod } = props;
    let comparePeriodComponent;
    if (comparePeriod){
        comparePeriodComponent = (
            <div className="openyoung-card-expenses-bars__previous-expenses">
                <ComparativeBarSimple
                    firstValue={comparePeriod}
                    totalValue={maxExpenses}
                    height={BAR_HEIGHT}
                    color={BAR_COLORS.secondary}
                />
            </div>
        );
    }
    return (
        <div>
            <div className="openyoung-card-expenses-bars__current-expenses">
                <ComparativeBarSimple
                    firstValue={currentPeriod}
                    totalValue={maxExpenses}
                    height={BAR_HEIGHT}
                    color={BAR_COLORS.main}
                />
            </div>
            {comparePeriodComponent}
        </div>
    );
};

OpenYoungCardExpensesBars.propTypes = {
    comparePeriod: PropTypes.number,
    currentPeriod: PropTypes.number.isRequired,
    maxExpenses: PropTypes.number.isRequired
}

module.exports = OpenYoungCardExpensesBars;
